import type { DataField } from '../..'
import CancelModal from '../../../../Components/CancelModal'
import { useStateValue } from '../../../../providers/StateProvider'
import { deleteField } from '../../../../services/field'
import { actionTypes } from '../../../../store/reducer'

interface ModalDeleteProps {
  selectedField: DataField
  setSelectedField: (field: DataField) => void
  showModalCancel: boolean
  setShowModalCancel: (open: boolean) => void
  setIsLoading: (open: boolean) => void
  isLoading: boolean
  handelRemoveFieldFromState: (field: DataField) => void
  getAllFields: () => Promise<void>
}

export function ModalDelete({ 
  selectedField, 
  setSelectedField,
  setShowModalCancel, 
  showModalCancel,
  isLoading,
  handelRemoveFieldFromState,
  getAllFields,
  setIsLoading
}: ModalDeleteProps){
  const [, dispatch] = useStateValue();

 const handleDeleteWithRequest = async () => {
    setIsLoading(true)
    
    try {
      await deleteField(selectedField.id, selectedField.formulario);
      handelRemoveFieldFromState(selectedField)

      dispatch({
        type: actionTypes.SET_FLASH_MESSAGE,
        flashMessage: {
          show: true,
          type: 'success',
          title: 'Sucesso',
          message: `O campo ${selectedField.titulo} foi apagado`,
        }
      })

      await getAllFields();
      setShowModalCancel(false);
      
    } catch (error) {
      console.log(error);
      dispatch({
        type: actionTypes.SET_FLASH_MESSAGE,
        flashMessage: {
          show: true,
          type: 'error-alt',
          title: 'Error',
          message: `Não foi possivel apagar o campo ${selectedField.titulo}`,
        }
      })
    } finally {
      setIsLoading(false)
      setShowModalCancel(false)
      setSelectedField(null)
    }
   
  };

  return (
    <CancelModal
      show={showModalCancel}
      handleShow={setShowModalCancel}
      title="Remover Campo"
      description='Tem certeza que deseja remover o campo?'
      handleActionOk={handleDeleteWithRequest}
      loading={isLoading}
  />
  )
}